import {CallDirection} from './consts'
import {EventBus} from '@/event-bus'
import {Events, MessageTypes} from '@/core-consts'
import imageUtils from '@utils/imageUtils'
import storage from '@utils/storage'
import {i18n} from '@/plugins/i18n'
import ChatExtra  from '@/chatextra'

let FileUtils = {}

function convertBase64ToBinary(base64) {
  let raw = window.atob(base64)
  let rawLength = raw.length
  let array = new Uint8Array(new ArrayBuffer(rawLength))
  for (let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i)
  }
  return array
}

function binaryToBase64(data) {
  return '' + btoa(String.fromCharCode(...data))
}

function convertMessage(msg, contact) {
  msg.userName = (contact !== undefined) ? contact.name : msg.user
  msg.userAvatar = (contact !== undefined) ? contact.avatar : ''

  let extra = new ChatExtra()
  for (let e in msg.extra) {
    ///console.log('-- extra', msg.extra[e])
    extra[msg.extra[e].key] = msg.extra[e].value
  }
  ///console.log('-- msg', msg, extra)
  msg.extra = extra

  if (msg.thumb.byteLength > 0)
    msg.thumb = binaryToBase64(msg.thumb)
} 

export default {

  launch: ({ commit }) => {
    return new Promise(async (resolve) => {
      let json = storage.get('settings')
      let sets = json ? JSON.parse(json) : {}

      if (window.isElectron) {
        if (sets.input !== undefined)
          EventBus.setAudioInputDevice(sets.input)
        if (sets.output !== undefined)
          EventBus.setAudioOutputDevice(sets.output)

        if (sets.inputVolume !== undefined)
          EventBus.setAudioInputVolume(sets.inputVolume)
        if (sets.outputVolume !== undefined)
          EventBus.setAudioOutputVolume(sets.outputVolume)        
      }

      if (sets.language && sets.language !== '') 
        i18n.locale = sets.language
      else if (window.navigator.userLanguage)
        i18n.locale = window.navigator.userLanguage
      else if (window.navigator.language) 
        i18n.locale = window.navigator.language

      let loc = i18n.locale.split('-')
      if (loc.length > 1)
        i18n.locale = loc[0]

      if (sets.language !== i18n.locale) {
        sets.language = i18n.locale
      }

      commit('setSettings', sets)

      let keys = storage.get('keys')
      keys = keys ? JSON.parse(keys) : {}
      await window.cryptManager.initialize(keys)
      console.log('-- cryptManager.initialize()', keys)

      if (Object.keys(keys).length === 0) {
        keys = window.cryptManager.keys()
        storage.set('keys', JSON.stringify(keys))
      }

      EventBus.launch()
      resolve()
    })    
  },

  userAuthorized: ({ commit, dispatch }, args) => {
    //console.log('--- userAuthorized:' + JSON.stringify(args))

    if (args.state == 0) {
      let profile = args
      profile.avatar = (profile.avatar.byteLength > 0) ? binaryToBase64(profile.avatar) : ''

      commit('setUserProfile', profile)
      ///commit('setConnectionState', 0)
      dispatch('updateConnectionState', 0)
    } else {
      commit('setUserProfile', {})
    }
    // notify UI
    EventBus.login = args.id ? args.id : ''
    EventBus.$emit('user-authorized', args.state == 0)
  },

  fetchContacts: async ({ commit }) => {
    let items = await EventBus.getContacts()
    items.map((item) => {
      item.avatar = (item.avatar.byteLength > 0) ? binaryToBase64(item.avatar) : ''
    })
    commit('setContacts', items)
    return items
  },

  addContact: async ({ dispatch }, item) => {
    await EventBus.addContact(item.contactId, item.username, convertBase64ToBinary(item.avatar))

    dispatch('fetchContacts').then(() => {
      console.log('--- addContact:', item.username)
      EventBus.$emit('contacts-changed')
    })
  },

  /// open add contact dialog
  showAddContact: (context, contactId) => {
    EventBus.$emit('open-add-contact', contactId)
  },
  /// open contact details (if contact was added)
  openContactDetails: (context, contactId) => {
    EventBus.$emit('open-contact-profile', contactId)
  },

  verifyContact: (context, contactId) => {
    return EventBus.verifyUser(contactId)
  },

  /// query all blocked contacts
  fetchBlockedContacts: ({ commit }) => {
    let items = EventBus.getBlockedContacts()
    //TODO: commit('setBlockedContacts', items)
    return items
  },
  /// remove contact
  removeContact: ({ dispatch }, contactId) => {
    EventBus.removeContact(contactId)
    dispatch('fetchContacts').then(() => {
      EventBus.$emit('contacts-changed')
    })
  },
  blockContact: (context, contactId) => {
    EventBus.blockContact(contactId)
    console.log(`--- blockContact: ${contactId}`)
  },
  unblockContact: (context, contactId) => {
    EventBus.unblockContact(contactId)
    console.log(`--- unblockContact: ${contactId}`)
  },
  unblockAllContacts: (context) => {
    EventBus.unblockAllContacts()
    console.log(`--- unblockAllContacts`)
  },

  addChat: async (context, { users, avatar, title }) => {
    let chatId = await EventBus.createChat(users)
    console.log(`--- addChat: ${chatId}`)

    EventBus.setChatDetails(chatId, avatar, title)

    // update chat list
    //this.dispatch('fetchChats')
    return chatId
  },

  addUsersToCurrentChat: ({ commit, state }, newUsers) => {
    const cid = state.currentChat.chatId
    EventBus.addUsersToChat(cid, newUsers)

    const users = state.currentChat.users.concat(newUsers)
    commit('setCurrentChat', { users: users })  
  },

  openGroupChat: ({ commit }, {chatId, users}) => {
    const ttl = EventBus.getChatTtl(chatId)
    commit('setCurrentChat', { 
      chatId: chatId, 
      users: users,
      single: false,
      ttl: ttl  
    })
  },

  openSingleChat: async ({ commit }, {contactId, chatId}) => {
    let cid = await EventBus.openSingleChat(contactId)
    if (chatId !== undefined && cid != chatId) {
      // TODO: update contact with new id
      throw new Error("Bad chatId[" + chatId + "] != cid[" + cid + "] for " + contactId)
    }

    const ttl = EventBus.getChatTtl(cid)
    commit('setCurrentChat', { 
      chatId: cid, 
      users: [contactId],
      single: true,
      ttl: ttl 
    })
    return cid
  },

  openChatById: ({ commit, state }, chatId) => {
    if (chatId != state.currentChat.chatId) {
      let chat = state.chats.find(it => it.chatId == chatId)
      if (chat) {
        commit('setCurrentChat', { 
          chatId: chatId, 
          users: chat.users,
          single: !chat.group,
          ttl: EventBus.getChatTtl(chatId),
          readonly: chat.readonly
        })
      }
    }
    EventBus.showMainWindow()
  },

  showMainWindow: (context) => {
    console.log('-- showMainWindow')
    EventBus.showMainWindow()
  },

  updateCurrentTtl: ({ commit, state }, value) => {
    EventBus.sendChatTtl(state.currentChat.chatId, value)
    commit('setCurrentTtl', value)
  },

  leaveChat: ({ commit, state }, chatId) => {
    EventBus.leaveChat(chatId)
    EventBus.removeChat(chatId)
    if (chatId == state.currentChat.chatId)
      commit('setCurrentChat', null)
  },
  deleteChat: ({ commit, state }, chatId) => {
    EventBus.removeChat(chatId)
    if (chatId == state.currentChat.chatId)
      commit('setCurrentChat', null)
  },
  resetCurrentChat: ({ commit, state }) => {
    commit('setCurrentChat', null)
  },

  uploadChatAvatar: async ({ commit }, {chatId, avatar}) => {
    await EventBus.setChatDetails(chatId, convertBase64ToBinary(avatar), '')
    commit('setChatAvatar', {chatId, data:avatar})
  },

  updateChatTitle: async (context, {chatId, title}) => {
    await EventBus.setChatDetails(chatId, '', title)
    // TODO: change title
  },

  sendMessage: ({ state }, { content, type, extra }) => {
    console.log(`--- sendMessage: ${content}, chatId: ` + state.currentChat.chatId)
    if (state.currentChat.chatId !== null)
      EventBus.sendChatMessage(state.currentChat.chatId, content, type, extra)
  },

  sendFile: ({ state }, { filePath, thumbPath, type, extra }) => {
    console.log(`--- sendFile: ${filePath} ${type}`)
    EventBus.sendChatFile(state.currentChat.chatId, filePath, thumbPath, type, extra)
  },

  sendAsImage: ({ state }, files) => {
    console.log('-- sendFiles: ', files)
    const cid = state.currentChat.chatId
    for (let i = 0; i < files.length; i++) {
      const item = files[i]
      const reader = new FileReader()
      reader.onload = function(e) { 
        let data = btoa(e.target.result)
        imageUtils.resizeImage(data, 250, 250).then(thumb => {
          console.log('-- resized: ', thumb)
          let extra = new ChatExtra()
          extra.setOriginalName(item.name)
          // TODO: replyId?
          EventBus.sendChatFile(cid, data, thumb, MessageTypes.Image, extra)
        })
      }
      reader.readAsBinaryString(item)
    }
  },

  sendAsDocument: ({ state }, files) => {
    console.log('-- sendFiles: ', files)
    let cid = state.currentChat.chatId

    for (let i = 0; i < files.length; i++) {
      const item = files[i]
      const reader = new FileReader()
      reader.onload = function(e) { 
        let extra = new ChatExtra()
        extra.setOriginalName(item.name)
        extra.setFileSize(item.size)
        EventBus.sendChatFile(cid, btoa(e.target.result), '', MessageTypes.Document, extra)
      }
      reader.readAsBinaryString(item)
    }
  },

  fetchRecents: async ({ commit, state }) => {
    let items = await EventBus.getRecentCalls()
    let contacts = state.contacts
    
    items.map((item) => {
      let contact = contacts.find(c => c.contactId === item.caller)
      item.name = (contact !== undefined) ? contact.name : item.caller
      item.avatar = (contact !== undefined) ? contact.avatar : ''
    })

    commit('setRecents', items)
    return items
  },

  removeRecent: (context, index) => {
    EventBus.removeRecent(index)
  },
  removeAllRecents: (context) => {
    EventBus.removeAllRecents()
  },
  markUnreadRecents: ({ commit, state }) => {
    EventBus.markUnreadRecents()

    let items = state.recents
    items.map(item => item.read = true)
    commit('setRecents', items)
  },

  fetchChats: async ({ commit, state }) => {
    let items = await EventBus.getChats()

    // reformat messages for ui
    items.map((item) => {
      item.group = item.type == 1
      if (item.group) {
        if (item.title === '') {
          let title = ''
          item.users.forEach(uid => {
            if (title.length > 0)
              title += ', '

            let contact = state.contacts.find(c => c.contactId === uid)
            title += (contact !== undefined) ? contact.name : uid
          })
          item.title = title
        }

        item.avatar = (item.avatar.byteLength > 0) ? binaryToBase64(item.avatar) : ''
      } else {
        let contact = state.contacts.find(c => c.contactId === item.users[0])
        item.title  = (contact !== undefined) ? contact.name : item.users[0]
        item.avatar = (contact !== undefined) ? contact.avatar : '' 
      }

      item.readonly = (item.type == 2)
      //item.title = 'Service Notifications'
    })

    //console.log('-- fetch chats: ', items)
    commit('setChats', items)
    return items
  }, 

  fetchChatMessages: async ({ commit, state }, { chatId, offset }) => {
    let msgs = await EventBus.getChatMessages(chatId, offset)
    //console.log('-- fetch msgs: ' + JSON.stringify(msgs), msgs.length)

    msgs.map((msg) => {
      const contact = state.contacts.find(c => c.contactId === msg.user)
      convertMessage(msg, contact)
    })
    return msgs
  },

  fetchChatMessage: async ({ state }, { chatId, messageId }) => {
    let msg = await EventBus.getChatMessage(chatId, messageId)
    console.log('-- fetch msg: ', msg)

    const contact = state.contacts.find(c => c.contactId === msg.user)
    convertMessage(msg, contact)
    return msg
  },

  searchNext: async (context, { chatId, offset, searchable }) => {
    let result = []
    let item = {}
    for (;;) {
      let msgs = await EventBus.getChatMessages(chatId, offset)
      if (msgs.length == 0)
        break

      offset += msgs.length

      result = result.concat(msgs)
      item = msgs.find(it => it.type == 0 && it.message.indexOf(searchable) >= 0)
      if (item)
        return { items: result, message: item }
    }
    return null
  },
  
  removeChatMessage: ({ commit, state }, { messageId, remotely }) => {
    EventBus.removeChatMessage(state.currentChat.chatId, messageId, remotely)
  },

  /**
   * @param recipientChat chat id of receiver
   */
  forwardChatMessage: ({ commit, state }, { recipientChat, message }) => {
    EventBus.forwardChatMessage(recipientChat, message.chatId, message.messageId)
  },

  decodeFile: async (context, filePath) => {
    let data = await EventBus.decodeFile(filePath)
    return binaryToBase64(data)
  },

  decodeFileToFile: (context, {filePath, outputFilePath}) => {
    return EventBus.decodeFileToFile(filePath, outputFilePath)
  },

  openFileAsTemporary: (context, filePath) => {
    /*const fileName = require('path').basename(filePath)
    const destPath = EventBus.getCacheFolderPath() + fileName

    return new Promise((resolve) => {
      const result = EventBus.decodeFileToFile(filePath, destPath)
      if (result) {
        require('electron').shell.openExternal(destPath)
      }
      resolve({ destPath, result })
    })*/
  },

  saveFileAs: (context, { path, name, filter }) => {
    /*const {dialog} = window.require('electron').remote
    let destPath = dialog.showSaveDialog({
      defaultPath:name,
      filters: filter,
    })
    return new Promise((resolve) => {
      let result
      if (destPath !== undefined) {
        result = EventBus.decodeFileToFile(path, destPath)
      }
      resolve({ destPath, result })
    })*/
  },

  clearHistory: (context, chatId) => {
    console.log('--- clearHistory: ', chatId)
    return new Promise((resolve) => {
      EventBus.clearChatMessages(chatId)
      //TODO: update state.chats
      EventBus.$emit('chat-changed', { action:Events.ChatChanged, chatId:chatId })
      resolve()
    })
  },

  fetchUserProfile: async ({commit, state}, contactId) => {
    if (!contactId || contactId === EventBus.getLogin()) {
      return state.profile
    }

    let profile = await EventBus.getUserProfile(contactId)
    console.log('-- (fetchUserProfile): ' + JSON.stringify(profile))
    return profile
  },

  updateUserProfile: ({commit, state}, { key, value }) => {
    EventBus.updateUserProfile(key, value)
    let p = Object.assign({}, state.profile)
    if (key == 'name')
      p.name = value
    else if (key == 'avatar')
      p.avatar = value
    commit('setUserProfile', p)
  },

  uploadUserAvatar: ({commit, state}, avatar) => {
    return new Promise((resolve) => {
      EventBus.updateUserProfile('avatar', convertBase64ToBinary(avatar))
      let p = Object.assign({}, state.profile)
      p.avatar = avatar
      commit('setUserProfile', p)
    })
  },
  uploadChatBackground: ({ commit,state }, background) => {
    let ext = FileUtils.extension(background)
    const backgroundCopy = EventBus.getUserFolderPath() + "bg-" + Date.now() + ext

    return new Promise((resolve) => {
      let s = Object.assign({}, state.settings)
      // remove old background
      if (s.background)
        FileUtils.removeFile(s.background)

      FileUtils.copyAttach(background, backgroundCopy).then(() => {
        s.background =  backgroundCopy
        commit('setSettings', s)
        resolve(backgroundCopy)
      })
    })
  },
  removeChatBackground: ({ commit,state }) => {
    let s = Object.assign({}, state.settings)
    FileUtils.removeFile(s.background)
    s.background = ''
    commit('setSettings', s)
  },
  fetchUserLogin: (context) => {
    let login = EventBus.getLogin()
    //commit('setLogin', login)
    return login
  },

  logout: (context, eraseUserData) => {
    return new Promise((resolve) => {
      const cachePath = EventBus.getCacheFolderPath()
      FileUtils.removeDir(cachePath)
      EventBus.sendLogout(eraseUserData)
      resolve()
    })
  },

  deleteAccount: () => {
    EventBus.deleteAccount()
  },

  exit: (context) => {
    EventBus.exit()
  },

  sendChatTyping: ({ state }, typing) => {
    //console.log(`-- sendChatTyping:  chatId: ` + state.currentChat.chatId + "typing:"+ typing)
    if (state.currentChat.chatId !== null)
      EventBus.sendChatTyping(state.currentChat.chatId, typing)
  },

  setChatMuted: ({ commit, state }, chat) => {
    if (chat === undefined) {
      chat = {
        chatId: state.currentChat.chatId,
        muted: !state.currentChat.muted
      }
    }
    commit('setChatMuted', { chatId: chat.chatId, muted: chat.muted })
    console.log('-- setChatMuted: ' + JSON.stringify(chat))
    EventBus.setChatMuted(chat.chatId, chat.muted)
  },

  /**
   * Called when chat timer is changed by other user
   */
  chatTtlChanged: ({ commit }, { chatId, ttl }) => {
    commit('setChatTtl', { chatId, ttl })
  },

  markReadChatMessage: ({ state }, messageId) => {
    EventBus.markReadChatMessage(state.currentChat.chatId, messageId)
  },

  unreadCountChanged: () => {
    // update tray
    ///ipcRenderer.send('unread-changed')
  },

  toggleTimerMonitoring: ({ commit }, {chatId, monitorChat}) => {
    EventBus.toggleTimerMonitoring(chatId, monitorChat)
  },

  /**
   * Call users
   */
  call: ({ commit }, users) => {
    console.log('-- call: ', users[0])

    commit('setCallDirection', CallDirection.outgoing)
    EventBus.call(users[0])

    EventBus.$emit('open-call-window')
  },
  // TODO: in the future we must use 'call' method
  addUsersToCall: ({ commit }, users) => {
    users.forEach(user => EventBus.call(user))
  },

  acceptCall: () => {
    EventBus.acceptCall()
  },
  declineCall: () => {
    EventBus.declineCall()
  },
  getCallUsers: ({state}) => {
    let items = EventBus.getCallUsers()
    items.map(item => {
      const con = state.contacts.find(c => c.contactId == item.contactId)
      item.avatar = con ? con.avatar : ''
      
      if (item.name === '#1')
        item.name = this.$t('contacts_echo')
    })
    return items
  },
  updateCallDirection: ({ commit }, direction) => {
    commit('setCallDirection', direction)
  },
  muteMicrophone: (context, mute) => {
    return EventBus.muteMicrophone(mute)
  },

  /**
   * PIN management
   */

  setApplicationPin: (context, pin) => {
    EventBus.$emit('pin-changed', true)
    return EventBus.setApplicationPin(pin)
  },
  verifyApplicationPin: (context, pin) => {
    console.log("-- actions verifyApplicationPin pin:" + pin)
    return EventBus.verifyApplicationPin(pin)
  },
  clearApplicationPin: () => {
    EventBus.$emit('pin-changed', false)
    EventBus.clearApplicationPin()
  },
  getPinTriesCount: () => {
    return EventBus.getPinTriesCount()
  },
  isApplicationPinSet: () => {
    return EventBus.isApplicationPinSet()
  },
  getApplicationPinSize: () => {
    return EventBus.getApplicationPinSize()
  },

  /**
   * 
   */
  getBackups: () => {
    let dir = EventBus.getUserFolderPath() + '../backups/' + EventBus.getLogin()
    let result = []
    FileUtils.enumFiles(dir).forEach(name => {
      result.push({
        name: name,
        filepath: dir + '/' + name
      })
    })
    return result
  },
  createBackup: (context, { name, password, withMedia }) => {
    let dir = EventBus.getUserFolderPath() + '../backups/'
    FileUtils.makeDir(dir)
    dir += EventBus.getLogin()
    FileUtils.makeDir(dir)

    return new Promise(resolve => {
      const filepath = dir + '/' + name + '.zip'
      EventBus.createBackup(filepath, password, withMedia)
      resolve(filepath)
    })
  },
  restoreBackup: ({commit}, { filepath, password }) => {
    return new Promise(resolve => {
      let r = EventBus.restoreBackup(filepath, password) == 0
      //if (r) 
      //  commit('setCurrentChat', null)
      resolve(r)
    })
  },

  readSettings: ({commit, state}) => {
    let json = storage.get('settings')
    let sets = json ? JSON.parse(json) : {}
    if (sets.language && sets.language !== '') 
      i18n.locale = sets.language
    else if (window.navigator.userLanguage)
      i18n.locale = window.navigator.userLanguage
    else if (window.navigator.language) 
      i18n.locale = window.navigator.language

    let loc = i18n.locale.split('-')
    if (loc.length > 1)
      i18n.locale = loc[0]

    if (sets.language !== i18n.locale) {
      sets.language = i18n.locale
    }

    commit('setSettings', sets)
    return sets
  },

  /**
   * 
   */
  getAudioSettings: () => {
    return EventBus.getAudioSettings()
  },

  setAudioInputDevice: ({ commit, state }, deviceId) => {
    let s = state.settings
    s.input = deviceId
    commit('setSettings', s)

    return EventBus.setAudioInputDevice(deviceId)
  },
  
  setAudioInputVolume: ({ commit, state }, volume) => {
    let s = state.settings
    s.inputVolume = volume
    commit('setSettings', s)

    return EventBus.setAudioInputVolume(volume)
  },
  
  setAudioOutputDevice: ({ commit, state }, deviceId) => {
    let s = state.settings
    s.output = deviceId
    commit('setSettings', s)

    return EventBus.setAudioOutputDevice(deviceId)
  },
  
  setAudioOutputVolume: ({ commit, state }, volume) => {
    let s = state.settings
    s.outputVolume = volume
    commit('setSettings', s)

    return EventBus.setAudioOutputVolume(volume)
  },
  updateSettings: ({commit}, sets) => {
    commit('setSettings', sets)
  },
  getCoreVersion: () => {
    return EventBus.getCoreVersion()
  },
  serverIdReceived: ({ commit },  serverId ) => {
    console.log("actions serverIdReceived")
    commit('setServerId',  serverId )
  },
  updateConnectionState: ({ commit }, state) => {
    commit('setConnectionState', state)
  },

  /// open message in MediaGallery
  showMediaGallery: (context, { message, progress }) => {
    EventBus.$emit('show-mediagallery', { message, progress })
  },

  setLanguage: ({ commit, state }, language) => {
    i18n.locale = language
    let s = state.settings
    s.language = language
    commit('setSettings', s)
    console.log("settings set to:" + language +JSON.stringify(s))
  },
  setTheme: ({ commit, state }, isDark) => {
    let s = state.settings
    if (s.theme !== isDark) {
      s.theme = isDark
      commit('setSettings', s)
      //console.log("settings set to:" + isDark + JSON.stringify(s))
      EventBus.$emit('theme-changed', isDark)
    }
  },

  openLink: (context, link) => {
    ///require('electron').shell.openExternal(link)
  },

  pasteImage: (context) => {
    /*const clipboard = require('electron').clipboard
    let image = clipboard.readImage()
    if (image.getSize()) {
      const data = image.toJPEG(90)
      //const s = data.toString()

      const destPath = EventBus.getCacheFolderPath() + Date.now().toString() + ".jpeg"
      FileUtils.writeFile(destPath, data)
      return destPath
    }*/
    return null
  },
  pasteText: (context) => {
    /*const clipboard = require('electron').clipboard
    let text = clipboard.readText('clipboard')
    return text*/
  },

  storeDraft: (context, { chatId, draft }) => {
    EventBus.storeDraft(chatId, draft)
  },

  restoreDraft: async (context, chatId) => {
    return await EventBus.restoreDraft(chatId)
  },

  updateFontSize({ commit, state }, fontSize){
    let s = state.settings
    s.fontSize =  fontSize
    commit('setSettings', s)
  },
  getUrlMetadata: (context, data) => {
    EventBus.getUrlMetadata(data)
  },

  localizationChanged: (context, data) => {
    // update tray
    //ipcRenderer.send('lang-changed', data[0], data[1])
  },

  connectWsc: async (context) => {    
    return await EventBus.connectWsc()
  },
  registerWscToken: async (context, token) => {
    let status = await EventBus.registerWscToken(token)
    storage.set('token', token)
    return status
  }
}
